import Vue from 'vue';
let that = new Vue();

export default function (auth, to, from) {
    if (!sensors) return;
    const userInfo = that.$utils.getUserInfo() || {};
    const SC_LOGIN = 'scLogin';
    if (auth.loggedIn()) {
      if (!userInfo.payor) {
        console.log('in')
        that.$apis.getCardInfo().then(res => res.data).then(data => {
            if (!data.msg) return;
            const msg = JSON.parse(data.msg);
            that.$utils.cacheUserInfo({
                ...that.$utils.getUserInfo(),
                payor: msg.payor,
                corpration: msg.corp
            })
        })
      }
      if (!sessionStorage.getItem(SC_LOGIN)) {
        sensors.login('medilink_'+userInfo.ylId);
      }
      sessionStorage.setItem(SC_LOGIN, 1);  
    } else {
      sessionStorage.removeItem(SC_LOGIN)
    }
  
    const trackPages = ['preAuthApply', 'claimapply', 'member', 'welfare',
      'JGQuery', 'BXCardManage', 'claimQuery', 
      'preAuthQuery', 'bankCard'
    ];
    const trackPagesName = ['预授权申请', '理赔申请', '首页', '保险福利', '直付网络', '关联家属的保险卡',
      '自助理赔进度查询', '预授权进度查询', '银行卡管理'
    ];
    const trackIndex = trackPages.indexOf(to.name);
    const KEY_PRE_SOURCE = 'preSource';
    if (trackIndex > -1) {
      let val = '';
      switch (from.name) {
        case null:
          // 已登录直接进来，或者刷新当前页面
          val = '菜单栏';
          if (sessionStorage.getItem(KEY_PRE_SOURCE)) {
            val = sessionStorage.getItem(KEY_PRE_SOURCE);
          }
        break;
        case 'login':
          // 登录后再进来
          val = '菜单栏';
          const sceneParams = JSON.parse(sessionStorage.getItem('scene') || '{}');
          if (sceneParams.card_id) {
            val = '微信卡包'
          }
        break;
        case 'member':
          val = '首页';
          if (to.query.card_id) {
            val = '微信卡包';
          }
        break;
        default: 
          val = '二级页面';
        break;
      }
      console.log('login -> ', val, from);
      sessionStorage.setItem(KEY_PRE_SOURCE, val);
      sensors.quick('autoTrack');
      sensors.track('medilink_view', {
        platform_share_from: val,
        $title: trackPagesName[trackIndex],
        payor: userInfo.payor || '',
        corpration: userInfo.corpration || ''
      });
    }
}